<template>
  <UICard title="Power mode">
    <UICheckbox v-model="powerMode" label="Enable power mode" />
  </UICard>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useSettingsStore } from '@/store/settings'

import { UICard } from '@ui/core'
import { UICheckbox } from '@ui/controllers'

const settingsStore = useSettingsStore()

const powerMode = computed<boolean>({
  get() {
    return settingsStore.getPowerMode
  },
  set(value) {
    settingsStore.setPowerMode(value)
  },
})
</script>
